var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVLo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0 0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-750 -1458)",
    stroke: "#FCBB00",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_2",
    transform: "translate(753 1461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.98 14.233L79.96 14.233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0844453,0 C78.2008862,0 79.9600115,1.75912334 79.9600115,8.79560431 L79.9600115,25.2273891 C79.9600115,32.2638701 78.2008862,34.0229782 71.0844453,34.0229782 L48.8555719,34.0229782 C41.739131,34.0229782 39.9800057,32.2638701 39.9800057,25.2273891 L39.9800057,8.79560431 C39.9800057,1.75912334 41.739131,0 48.8555719,0 L71.0844453,0 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 60.21L39.98 60.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1044396,45.9770066 C38.2208805,45.9770066 39.9800057,47.7361299 39.9800057,54.7726109 L39.9800057,71.2043957 C39.9800057,78.2408767 38.2208805,80 31.1044396,80 L8.87556615,80 C1.75912525,80 0,78.2408767 0,71.2043957 L0,54.7726109 C0,47.7361299 1.75912525,45.9770066 8.87556615,45.9770066 L31.1044396,45.9770066 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9600115 51.9740074C79.9600115 67.4462692 67.4462692 79.9600115 51.9740074 79.9600115L56.1718592 72.9635105M0 27.986004C0 12.5137423 12.5137423 0 27.986004 0L23.7881522 6.996501",
    id: "Vector"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo2);
export default __webpack_public_path__ + "static/media/v_lo_2.b793c3fbb63ac4d1d6a0f940ba4f0963.svg";
export { ForwardRef as ReactComponent };